import React from 'react';

const caseStudies = [
  {
    id: 1,
    title: "Streamlining Patient Education for Cardiology Practices",
    description: "How our comprehensive patient education platform can transform the patient experience and improve practice efficiency.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    benefits: [
      "Reduce staff time spent on repetitive explanations",
      "Decrease pre-procedure anxiety with clear information",
      "Minimize cancellations through better preparation"
    ],
    specialty: "Cardiology"
  },
  {
    id: 2,
    title: "Digital Patient Onboarding for Multi-Location Practices",
    description: "How our digital intake and education system can transform operations and improve patient preparation.",
    image: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    benefits: [
      "Automate repetitive administrative tasks",
      "Eliminate paperwork errors and redundancy",
      "Improve patient preparation and compliance"
    ],
    specialty: "Orthopedics"
  },
  {
    id: 3,
    title: "Growing Patient Engagement in Aesthetic Medicine",
    description: "How targeted educational content and marketing strategies can expand your patient base and improve conversion rates.",
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    benefits: [
      "Increase consultation bookings",
      "Improve procedure conversion rates",
      "Boost social media engagement"
    ],
    specialty: "Dermatology"
  }
];

const CaseStudies: React.FC = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {caseStudies.map((study) => (
        <div key={study.id} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full">
          <div className="h-48 overflow-hidden">
            <img 
              src={study.image} 
              alt={study.title} 
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="p-6 flex-grow">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-blue-600 bg-blue-100 rounded-full mb-3">
              {study.specialty}
            </span>
            <h3 className="text-xl font-bold text-gray-900 mb-2">{study.title}</h3>
            <p className="text-gray-600 mb-4">{study.description}</p>
            <div className="mt-auto">
              <h4 className="font-semibold text-gray-800 mb-2">Key Benefits:</h4>
              <ul className="space-y-1 mb-4">
                {study.benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start text-sm">
                    <svg className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="p-6 border-t border-gray-100">
            <div className="flex justify-center">
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center justify-center px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200 group"
              >
                Learn More
                <svg className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CaseStudies;